import React from 'react';
// import './MenuArrow.scss';

const MenuArrow = () => {
    return (
        <svg height='7px' version='1.1' viewBox='0 0 10 7' width='10px' xmlns='http://www.w3.org/2000/svg'>
            <g fill='none' id='Page-1' stroke='none' strokeWidth='1'>
                <g fill='#000000' id='Core' transform='translate(-469.000000, -9.000000)'>
                    <g id='arrow-drop-down' transform='translate(469.000000, 9.500000)'>
                        <path d='M0,0 L5,5 L10,0 L0,0 Z' id='Shape' />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default MenuArrow;